import managerOperateLog from './managerOperateRecord';
import loginRecord from './loginRecord';

const recordLanguages = [
    managerOperateLog,
    loginRecord,
]

export default recordLanguages;


// WEBPACK FOOTER //
// ./src/language/record/index.js